import { components } from 'react-select'
import LawFirmSearchOptionLabel from './LawFirmSearchOptionLabel'

/** Custom option only — do not replace SingleValue (breaks the closed control chevron layout). */
export const LawFirmAsyncOption = (props) => {
    const { data } = props
    return (
        <components.Option {...props}>
            <LawFirmSearchOptionLabel
                label={data.label}
                code={data.code}
                name={data.name}
                verified={data.verified}
            />
        </components.Option>
    )
}
